module.exports = __webpack_public_path__ + "static/media/down-arrow-orange.120cfefe.svg";